import Radio from "./radio/Radio";
import Toggle from "./toggle/Toggle";
import Select from "./select/Select";
import Slider from "./slider/Slider";
import TextInput from "./input/TextInput";
import PreferredTitleSelect from "./select/PreferredTitleSelect";
import Checkbox from "./checkbox/Checkbox";

class FormHelper {
    static getComponent(field, fieldData, form, updateForm, initialError){
        switch (fieldData[field].type) {
            case "radio":
                return <Radio id={field} required={fieldData[field].required} value={form[field]}
                              updateObject={updateForm} initialError={initialError} options={fieldData[field].options}
                              title={fieldData[field].title}  />;
            case "toggle":
                return <Toggle id={field} required={fieldData[field].required} value={form[field]}
                               updateObject={updateForm} initialError={initialError} values={fieldData[field].values}
                               title={fieldData[field].title} />;
            case "select":
                return <Select id={field} required={fieldData[field].required} value={form[field]}
                               updateObject={updateForm} initialError={initialError} options={fieldData[field].options}
                               title={fieldData[field].title} groups={"groups" in fieldData[field] ? fieldData[field].groups : false} />;
            case "slider":
                return <Slider id={field} required={fieldData[field].required} value={form[field]}
                                updateObject={updateForm} initialError={initialError}
                                min={fieldData[field].min} max={fieldData[field].max} step={fieldData[field].step}
                                title={fieldData[field].title} />;
            case "checkbox":
                return <Checkbox id={field} required={fieldData[field].required} value={form[field]}
                               updateObject={updateForm} initialError={initialError} title={fieldData[field].title} />;
            case "preferredTitleSelect":
                return <PreferredTitleSelect id={field} required={fieldData[field].required} value={form[field]}
                                             updateObject={updateForm} initialError={initialError} title={fieldData[field].title} />;
            default:
                return <TextInput id={field} type={fieldData[field].type} required={fieldData[field].required}
                                  value={form[field]} updateObject={updateForm} initialError={initialError}
                                  title={fieldData[field].title} />;
        }
    }
}

export default FormHelper;